import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'

const propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  white: PropTypes.bool,
}

const Button = ({ text, to, outline }) => (
  <Link className={outline ? 'button button--outline' : 'button'} to={to}>
    {text}
  </Link>
)

Button.propTypes = propTypes

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js